function toDoubleDigits(num: number | string) {
  return Number(num) < 10 ? `0${num}` : Number(num);
}

// 秒 -> 00 : 00 : 00格式
export function secondToTime(pldSecond: number): string {
  const minute = Math.floor(pldSecond / 60);
  const second = Math.floor(pldSecond % 60);
  return `${toDoubleDigits(minute)} : ${toDoubleDigits(second)}`;
}
